import {
  Church, Wine, UtensilsCrossed, Music, PartyPopper,
  Sparkles, Camera, Heart, Gem, Clock,
} from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

const ICONOS = {
  iglesia: Church,
  copas: Wine,
  cena: UtensilsCrossed,
  musica: Music,
  fiesta: PartyPopper,
  brillo: Sparkles,
  camara: Camera,
  corazon: Heart,
  anillos: Gem,
  reloj: Clock,
};

export default function Itinerario({ datos, seccion }) {
  const items = datos.itinerario || [];
  if (items.length === 0) return null;

  return (
    <section className="we-seccion" aria-label={seccion.titulo}>
      <div className="we-seccion-interior">
        <EncabezadoSeccion etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="we-titulo-itinerario" />
        <Reveal>
          <ul className="we-itinerario">
            {items.map((item, i) => {
              const Icono = ICONOS[item.icono] || Clock;
              return (
                <li className="we-itinerario-item" key={i} data-testid={`we-itinerario-item-${i}`}>
                  <span className="we-itinerario-icono">
                    <Icono strokeWidth={1.5} />
                  </span>
                  <div>
                    <p className="we-itinerario-hora">{item.hora}</p>
                    <h3 className="we-itinerario-titulo">{item.titulo}</h3>
                    {item.descripcion && <p className="we-itinerario-desc">{item.descripcion}</p>}
                  </div>
                </li>
              );
            })}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
